module.exports = __webpack_public_path__ + "static/vr-favicon.6d7ebe4a.ico";


//////////////////
// WEBPACK FOOTER
// ./assets/favicon/vr-favicon.ico
// module id = 799
// module chunks = 114276838955818